import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { useUserStoreWithOut } from '/@/store/modules/user';

const reference: AppRouteModule = {
  path: '/',
  name: 'Common',
  component: LAYOUT,
  meta: {
    hideChildrenInMenu: true,
    orderNo: 2,
    icon: 'icon-linggan',
  },
  children: [
    {
      path: '/discovery',
      name: 'discovery',
      meta: {
        title: '精选内容',
        ignoreKeepAlive: false,
        hideMenu: true,
      },
      beforeEnter: (_, __, next) => {
        try {
          const store = useUserStoreWithOut();
          if (store?.userInfo?.solution === 'art') {
            next({
              name: 'inspiration',
            });
            return;
          }
        } catch (e) {
          console.error(e);
        }
        next();
      },
      component: () => import('/@/views/discovery/index.vue'),
    },
    {
      path: '/ai-box',
      name: 'AIBOX',
      meta: {
        title: 'AI工具箱',
        ignoreKeepAlive: false,
        hideMenu: true,
      },
      component: () => import('/@/views/AIBox/index.vue'),
    },
  ],
};

export default reference;
